import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import { DialogProgrammatic as Dialog } from "buefy";
export interface CustomerSpecificPrices {
  /** TODO: Fill with attributes */
  placeholder: string;
}
function dateFormatter(dt: any) {
  if (dt == "Invalid Date") {
    return null;
  }
  if (dt != null) {
    return dt.toLocaleDateString("fr-CA");
  }
  return dt;
}
export default class CustomerSpecificPricesService {
  private httpClient = makeHttpClient();

  export(ids: number[], customerId: number) {
    const params = new URLSearchParams();
    if (ids.length == 0) {
      throw new Error("NOTHING TO EXPORT");
    } else {
      ids.map(id => {
        params.append("id", "" + id);
      });
      const url = `${
        env.customerUrl
      }export/customer/specificfee/?customer_id=${customerId}&${params.toString()}`;
      this.httpClient
        .get(url, { responseType: "blob" })
        .then(({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "CustomerSpecificPrices.xlsx"); //any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(err => {
          Dialog.alert({
            title: "Export not possible",
            message:
              "There was an error exporting customer specific prices. Please contact your Customer Account Manager.",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          return err;
        });
    }
  }
  upload(file: File, customer_id: any) {
    /*
                Initialize the form data
            */
    const formData = new FormData();

    /*
               Add the form data we need to submit
           */
    formData.append("specific_prices", file);

    let url = `${env.customerUrl}import/customer/specificfee/`;
    if (customer_id != null) {
      url = `${url}?customer_id=${customer_id}`;
    }
    return this.httpClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  getAll(customer_id: number, query: any) {
    if (query) {
      return _unwrapAxiosResponse(
        this.httpClient.get<CustomerSpecificPrices>(
          env.customerUrl +
            "customer/specificfee/?id=" +
            customer_id +
            "&" +
            query
        )
      );
    }
    if (customer_id && !isNaN(customer_id)) {
      return _unwrapAxiosResponse(
        this.httpClient.get<CustomerSpecificPrices>(
          env.customerUrl + "customer/specificfee/?id=" + customer_id
        )
      );
    } else {
      return null;
    }
  }

  create(form: any) {
    const data = {
      customer: form.customer,
      country: form.country,
      scheme: form.scheme,
      stream: form.stream,
      reporting_main_category: form.reporting_main_category,
      reporting_category: form.reporting_category_id,
      reporting_sub_category: form.reporting_sub_category,
      fee_per_kg: Number(form.fee_per_kg),
      fee_per_unit: Number(form.fee_per_unit),
      valid_from: dateFormatter(form.valid_from),
      valid_to: dateFormatter(form.valid_to)
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<CustomerSpecificPrices>(
        env.customerUrl + "customer/specificfee/",
        data
      )
    );
  }

  update(form: any) {
    const data = {
      customer: form.customer,
      country: form.country,
      scheme: form.scheme,
      stream: form.stream,
      reporting_main_category: form.reporting_main_category,
      reporting_category: form.reporting_category_id,
      reporting_sub_category: form.reporting_sub_category,
      fee_per_kg: Number(form.fee_per_kg),
      fee_per_unit: Number(form.fee_per_unit),
      valid_from: dateFormatter(form.valid_from),
      valid_to: dateFormatter(form.valid_to)
    };
    return _unwrapAxiosResponse(
      this.httpClient.put<CustomerSpecificPrices>(
        env.customerUrl + "customer/specificfee/" + form.id + "/",
        data
      )
    );
  }

  delete(cred_id: any) {
    const url = env.customerUrl + "customer/specificfee/" + cred_id + "/";
    return _unwrapAxiosResponse(
      this.httpClient.delete<CustomerSpecificPrices>(url)
    );
  }

  getReportingTypes(form: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<CustomerSpecificPrices>(
        "/api/reportingcategories/?country=" +
          form.country +
          "&scheme=" +
          form.scheme +
          "&stream=" +
          form.stream
      )
    );
  }
}
